import apiClient from './apiClient';

export const fetchReperibilitaByMonth = async (month) => {
    const response = await apiClient.get(`/reperibilita.php?action=get_by_month&month=${month}`);
    if (response.data.success) return response.data.data;
    throw new Error(response.data.error);
};

export const saveReperibilita = async (data) => {
    const response = await apiClient.post('/reperibilita.php', { action: 'save', ...data });
    if (response.data.success) return response.data.id;
    throw new Error(response.data.error);
};

export const updateReperibilita = async (data) => {
    const response = await apiClient.post('/reperibilita.php', { action: 'update', ...data });
    if (response.data.success) return true;
    throw new Error(response.data.error);
};

export const deleteReperibilita = async (id) => {
    const response = await apiClient.post('/reperibilita.php', { action: 'delete', id });
    if (response.data.success) return true;
    throw new Error(response.data.error);
};
